.beamerWrapper {
  display: flex;

  > span {
    width: 32px;

    > div {
      margin-top: 8px;
    }
  }
}
